export default "__VITE_ASSET__tma4lR$B__"